module.exports = __webpack_public_path__ + "img/title-6-c9039c.png";